export default __webpack_public_path__ + "static/test_tom_2-c133c8cbd03203e1003cc2b9febdd6bf.png";